export const FOCUSABLE_ELEMENTS = [
  'a[href]',
  'button:not([disabled]):not([aria-hidden])',
  '[tabindex]:not([tabindex^="-"])',
]
